/**
 * Leadership, client-supplied.
 *
 * Portraits and profile links supplied by the client. Cards fall back to a
 * branded monogram whenever `photo` is absent.
 *
 * The Director is first and receives the carousel's initial emphasis.
 */

export interface Leader {
  name: string;
  title: string;
  /** Derived from `name` when omitted. */
  initials?: string;
  /** Optional headshot path under public/. Monogram renders when absent. */
  photo?: string;
  /** Optional LinkedIn profile URL. */
  linkedin?: string;
}

export const leadership: Leader[] = [
  {
    name: 'Khalid Latif',
    title: 'Director',
    photo: '/team/khalid-latif.png',
    linkedin: 'https://www.linkedin.com/in/khalid-latif-796840b/',
  },

  {
    name: 'Abdul Moiz',
    title: 'Founder & Chief Information Officer',
    photo: '/team/abdul-moiz.jpeg',
    linkedin: 'https://www.linkedin.com/in/abdulmoiz72/',
  },
  {
    name: 'Mirza Hamza',
    title: 'CEO & Co-Founder',
    photo: '/team/mirza-hamza.png',
    linkedin: 'https://www.linkedin.com/in/mirza-hamza-ahsan/',
  },
  {
    name: 'Hamza Zohaib',
    title: 'Chief Technology Officer',
    photo: '/team/hamza-zohaib.jpeg',
    linkedin: 'https://www.linkedin.com/in/hamzazohaib/',
  },
  {
    name: 'Jawad Aziz',
    title: 'Senior DevOps Engineer',
    photo: '/team/jawad-aziz.png',
    linkedin: 'https://www.linkedin.com/in/jawad-aziz/',
  },
];

/** "Mirza Hamza" -> "MH" */
export function initialsOf(leader: Leader): string {
  if (leader.initials) return leader.initials;
  return leader.name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}
